import React from 'react';
import { Box, Controller, useFormContext } from '@common-fe/common-fe';

import { IRoleSetup } from '../role.types';

import FieldLevelAccessDropdown from './FieldLevelAccessDropdown';

interface Props {
  isEditMode?: boolean;
  id?: string;
}
const FieldLevelAccess: React.FC<Props> = ({ isEditMode, id }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IRoleSetup>();
  return (
    <Box>
      <Controller
        name="fieldLevelAccessId"
        control={control}
        render={({ field }) => (
          <FieldLevelAccessDropdown
            defaultId={id}
            errorText={errors?.fieldLevelAccessId?.message}
            isEditMode={isEditMode}
            value={field.value}
            onChangeValue={field.onChange}
          />
        )}
      />
    </Box>
  );
};

export default FieldLevelAccess;
